import AuthService from '@/modules/authentication/services/auth.service'
import AuthenticationConst from '@/modules/authentication/authentication.const'
import types from './authentication.actiontype'

const envAuthService = process.env.VUE_APP_AUTHENTICATION_SERVICE

const state = {
    token: AuthService.getToken(),
    profile: {},
    roles: [],
    authenticationService: envAuthService || AuthenticationConst.authenticationService.FPT_ID
}

const mutations = {
    [types.TOKEN]: (state, token) => {
        state.token = token
        AuthService.setToken(token)
    },
    [types.PROFILE]: (state, profile) => {
        state.profile = profile
        state.roles = Array.isArray(profile.roles) ? profile.roles : []
        state.isProfileLoaded = true
    }
}

const actions = {
    [types.GET_PROFILE] ({ commit }) {
        AuthService.getProfile().then(
            result => {
                commit(types.PROFILE, result.data)
            },
            error => {
                console.log(error)
                window.vueapp.$appService.toastError(this.$t('canNotGetUserProfile'))
            }
        )
    },
    [types.GET_JWT_USER]: ({ commit }, code) => {
        return new Promise((resolve, reject) => {
            AuthService.getJwtUser(code).then(res => {
                commit(types.PROFILE, res.data)
                commit(types.TOKEN, res.data.token)
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    },
    [types.RESET_TOKEN] ({ commit }) {
        return new Promise(resolve => {
            commit(types.TOKEN, '')
            commit(types.PROFILE, {})
            AuthService.removeToken()
            resolve()
        })
    },
    [types.SIGN_IN] () {
        AuthService.signIn()
    },
    [types.SIGN_OUT] ({ commit }) {
        commit(types.TOKEN, '')
        commit(types.PROFILE, {})
        AuthService.signOut()
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
